import { lentComponent, useContractMutation, useContractQuery, useInvalidateContract } from "@amtana/browser";
import type { LentToken, MutationResult, QueryResult } from "@amtana/browser";
import { settingsTrpcContract } from "@amtana/settings-contract";
import type { PurgeResult, Usage } from "@amtana/settings-contract";

export function useUsage(): QueryResult<Usage> {
  return useContractQuery(settingsTrpcContract, "usage", { input: {} });
}

/** A purge empties analyses and prospects everywhere, so every read refreshes. */
export function usePurge(): MutationResult<PurgeResult, { confirm: true }> {
  const mutation = useContractMutation(settingsTrpcContract, "purge");
  const invalidate = useInvalidateContract();
  const typed = mutation as unknown as MutationResult<PurgeResult, { confirm: true }>;
  return {
    ...typed,
    run: (input: { confirm: true }) => typed.mutateAsync(input).finally(() => void invalidate()),
  };
}

/** Purging all lead data: a panel the organization's settings page shows above its danger zone. */
export const PurgeDataPanel: LentToken<Record<string, never>> = lentComponent<Record<string, never>>(
  "settings",
  "PurgeDataPanel",
);
